module.exports = __webpack_public_path__ + "img/img-kiosk-sec-05.png";